export default {
  messageCenter: 'Message Center',
  all: 'All',
  clientPriceQuery: 'View Details',
  unreadOnly: 'Unread Only',
  markAllAsRead: 'Mark All as Read',
  messageSetting: 'Message Settings',
  messageCategory: 'Message Category',
  search: 'Search',
  query: 'Query',
  selectTimeRange: 'Select Time Range',
  startTime: 'Start Time',
  endTime: 'End Time',
  messageList: 'Message List',
  noData: 'No messages',
  unreadCount: 'Unread Messages',
  allMessages: 'All Messages',
  messageTitle: 'Message Title',
  messageContent: 'Message Content',
  sendTime: 'Send Time',
  sender: 'Sender',
  markAsRead: 'Mark as Read',
  delete: 'Delete',
  view: 'View',
  noMessages: 'No messages',
  loading: 'Loading...',
  subscriptionManagement: 'Subscription Management',
  selectCategories: 'Select message categories to subscribe',
  subscribe: 'Subscribe',
  unsubscribe: 'Unsubscribe',
  save: 'Save',
  cancel: 'Cancel',
  close: 'Close',
  confirm: 'Confirm',
  success: 'Success',
  error: 'Error',
  total: 'Total',
  items: 'items',
  page: 'Page',
  rows: 'rows',
  noMoreData: 'No more data',
  searchPlaceholder: 'Search messages by keyword',
  categoryMessages: '{count} unread',
  pleasePick: 'Please select time range',
  from: 'to',
  noPermission: 'You do not have permission to access this page'
}
